module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds.52d08f6ac72c023278730531fff11b01.png";